import { Link } from 'wouter'
import { ArrowLeft01Icon, Home01Icon } from '@hugeicons/core-solid-rounded'
import { Trans } from '@lingui/react/macro'

import image404 from '@/assets/404.png'
import Button from '@/components/ui/Button'

const Route404 = function () {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="max-w-2xl w-full text-center space-y-8">
        <div className="w-full flex justify-center mb-8">
          <img src={image404} />
        </div>

        <div className="space-y-4">
          <h2 className="text-heading2 text-primary">
            <Trans>Page not found</Trans>
          </h2>
          <p className="text-gray-500 max-w-md mx-auto">
            <Trans>
              The page you&apos;re looking for doesn&apos;t exist or has been
              moved. Let&apos;s get you back on track.
            </Trans>
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
          <Button
            onClick={() => window.history.back()}
            Icon={ArrowLeft01Icon}
            variant="outline"
          >
            <Trans>Back</Trans>
          </Button>
          <Link to="/goodies">
            <Button Icon={Home01Icon}>
              <Trans>Back to Home</Trans>
            </Button>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Route404
